<template>
  <div class="change-device-dialog">
    <div>
      <h1 class="item-title">{{ $t('components_offline_service.shen_qing_xin_xi') }}</h1>
      <div class="item-title-info">
        <el-row>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.shen_qing_ren') }}:</span>
            <span class="value">{{ detail.creator }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.shen_qing_shi_jian') }}:</span>
            <span class="value">{{ detail.gmtModified }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">Modem SN:</span>
            <span class="value">{{ detail.modemSn }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.sqrssgs') }}:</span>
            <span class="value">{{ detail.orgName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.shuo_ming') }}:</span>
            <span class="value">{{ detail.applyDesc }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.zai_xian') }}:</span>
            <span class="value"> {{ getDicValue('isynergy_cloud_bool', detail.isOnline) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">modem {{ $t('components_offline_service.ruan_jian') }}:</span>
            <span class="value">{{ detail.modemFwVersion }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">modem {{ $t('components_offline_service.ying_jian') }}:</span>
            <span class="value">{{ detail.modemHwVersion }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.xie_yi_ban_ben') }}:</span>
            <span class="value">{{ detail.tcpVersion }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_offline_service.sheng_dian_mo_shi') }}:</span>
            <span class="value">{{  getDicValue('isynergy_cloud_bool', detail.isPowerSave) }}</span>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },

  data() {
    return {
      orgList: [],
      detail: {},
      dataList: [],
      selectDevice: [],
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: []
      },
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [{ required: true, message: this.$t('Common.com_required') }, { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }]
      };
    },
    isSubmit: vm => !vm.selectDevice.length
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail();
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail();
      }
    },

    // 获取变更详情
    getChangeDetail: function () {
      this.$getJSON(`${apis.serviceModemInfo}/${this.model.changeId}`).then((res) => {
        this.detail = res.data || {};
      });
    },


  }
};
</script>

<style lang="scss"></style>
